export * from './VSCAccount';
export * from './VSCActivateBreakpoints';
export * from './VSCAdd';
export * from './VSCArchive';
export * from './VSCArrowBoth';
export * from './VSCArrowCircleDown';
export * from './VSCArrowCircleLeft';
export * from './VSCArrowCircleRight';
export * from './VSCArrowCircleUp';
export * from './VSCArrowDown';
export * from './VSCArrowLeft';
export * from './VSCArrowRight';
export * from './VSCArrowSmallDown';
export * from './VSCArrowSmallLeft';
export * from './VSCArrowSmallRight';
export * from './VSCArrowSmallUp';
export * from './VSCArrowSwap';
export * from './VSCArrowUp';
export * from './VSCAzureDevops';
export * from './VSCAzure';
export * from './VSCBeakerStop';
export * from './VSCBeaker';
export * from './VSCBellDot';
export * from './VSCBellSlashDot';
export * from './VSCBellSlash';
export * from './VSCBell';
export * from './VSCBlank';
export * from './VSCBold';
export * from './VSCBook';
export * from './VSCBookmark';
export * from './VSCBracketDot';
export * from './VSCBracketError';
export * from './VSCBriefcase';
export * from './VSCBroadcast';
export * from './VSCBrowser';
export * from './VSCBug';
export * from './VSCCalendar';
export * from './VSCCallIncoming';
export * from './VSCCallOutgoing';
export * from './VSCCaseSensitive';
export * from './VSCCheckAll';
export * from './VSCCheck';
export * from './VSCChecklist';
export * from './VSCChevronDown';
export * from './VSCChevronLeft';
export * from './VSCChevronRight';
export * from './VSCChevronUp';
export * from './VSCChromeClose';
export * from './VSCChromeMaximize';
export * from './VSCChromeMinimize';
export * from './VSCChromeRestore';
export * from './VSCCircleFilled';
export * from './VSCCircleLargeFilled';
export * from './VSCCircleLarge';
export * from './VSCCircleSlash';
export * from './VSCCircleSmallFilled';
export * from './VSCCircleSmall';
export * from './VSCCircle';
export * from './VSCCircuitBoard';
export * from './VSCClearAll';
export * from './VSCClippy';
export * from './VSCCloseAll';
export * from './VSCClose';
export * from './VSCCloudDownload';
export * from './VSCCloudUpload';
export * from './VSCCloud';
export * from './VSCCode';
export * from './VSCCollapseAll';
export * from './VSCColorMode';
export * from './VSCCombine';
export * from './VSCCommentDiscussion';
export * from './VSCCommentUnresolved';
export * from './VSCComment';
export * from './VSCCompassActive';
export * from './VSCCompassDot';
export * from './VSCCompass';
export * from './VSCCopy';
export * from './VSCCreditCard';
export * from './VSCDash';
export * from './VSCDashboard';
export * from './VSCDatabase';
export * from './VSCDebugAll';
export * from './VSCDebugAltSmall';
export * from './VSCDebugAlt';
export * from './VSCDebugBreakpointConditionalUnverified';
export * from './VSCDebugBreakpointConditional';
export * from './VSCDebugBreakpointDataUnverified';
export * from './VSCDebugBreakpointData';
export * from './VSCDebugBreakpointFunctionUnverified';
export * from './VSCDebugBreakpointFunction';
export * from './VSCDebugBreakpointLogUnverified';
export * from './VSCDebugBreakpointLog';
export * from './VSCDebugBreakpointUnsupported';
export * from './VSCDebugConsole';
export * from './VSCDebugContinueSmall';
export * from './VSCDebugContinue';
export * from './VSCDebugCoverage';
export * from './VSCDebugDisconnect';
export * from './VSCDebugLineByLine';
export * from './VSCDebugPause';
export * from './VSCDebugRerun';
export * from './VSCDebugRestartFrame';
export * from './VSCDebugRestart';
export * from './VSCDebugReverseContinue';
export * from './VSCDebugStackframeActive';
export * from './VSCDebugStackframe';
export * from './VSCDebugStart';
export * from './VSCDebugStepBack';
export * from './VSCDebugStepInto';
export * from './VSCDebugStepOut';
export * from './VSCDebugStepOver';
export * from './VSCDebugStop';
export * from './VSCDebug';
export * from './VSCDesktopDownload';
export * from './VSCDeviceCameraVideo';
export * from './VSCDeviceCamera';
export * from './VSCDeviceMobile';
export * from './VSCDiffAdded';
export * from './VSCDiffIgnored';
export * from './VSCDiffModified';
export * from './VSCDiffRemoved';
export * from './VSCDiffRenamed';
export * from './VSCDiff';
export * from './VSCDiscard';
export * from './VSCEdit';
export * from './VSCEditorLayout';
export * from './VSCEllipsis';
export * from './VSCEmptyWindow';
export * from './VSCErrorSmall';
export * from './VSCError';
export * from './VSCExclude';
export * from './VSCExpandAll';
export * from './VSCExport';
export * from './VSCExtensions';
export * from './VSCEyeClosed';
export * from './VSCEye';
export * from './VSCFeedback';
export * from './VSCFileBinary';
export * from './VSCFileCode';
export * from './VSCFileMedia';
export * from './VSCFilePdf';
export * from './VSCFileSubmodule';
export * from './VSCFileSymlinkDirectory';
export * from './VSCFileSymlinkFile';
export * from './VSCFileZip';
export * from './VSCFile';
export * from './VSCFiles';
export * from './VSCFilterFilled';
export * from './VSCFilter';
export * from './VSCFlame';
export * from './VSCFoldDown';
export * from './VSCFoldUp';
export * from './VSCFold';
export * from './VSCFolderActive';
export * from './VSCFolderLibrary';
export * from './VSCFolderOpened';
export * from './VSCFolder';
export * from './VSCGear';
export * from './VSCGift';
export * from './VSCGistSecret';
export * from './VSCGist';
export * from './VSCGitCommit';
export * from './VSCGitCompare';
export * from './VSCGitMerge';
export * from './VSCGitPullRequestClosed';
export * from './VSCGitPullRequestCreate';
export * from './VSCGitPullRequestDraft';
export * from './VSCGitPullRequestGoToChanges';
export * from './VSCGitPullRequestNewChanges';
export * from './VSCGitPullRequest';
export * from './VSCGithubAction';
export * from './VSCGithubAlt';
export * from './VSCGithubInverted';
export * from './VSCGithub';
export * from './VSCGlobe';
export * from './VSCGoToFile';
export * from './VSCGrabber';
export * from './VSCGraphLeft';
export * from './VSCGraphLine';
export * from './VSCGraphScatter';
export * from './VSCGraph';
export * from './VSCGripper';
export * from './VSCGroupByRefType';
export * from './VSCHeartFilled';
export * from './VSCHeart';
export * from './VSCHistory';
export * from './VSCHome';
export * from './VSCHorizontalRule';
export * from './VSCHubot';
export * from './VSCInbox';
export * from './VSCIndent';
export * from './VSCInfo';
export * from './VSCInspect';
export * from './VSCIssueDraft';
export * from './VSCIssueReopened';
export * from './VSCIssues';
export * from './VSCItalic';
export * from './VSCJersey';
export * from './VSCJson';
export * from './VSCKebabVertical';
export * from './VSCKey';
export * from './VSCLaw';
export * from './VSCLayersActive';
export * from './VSCLayersDot';
export * from './VSCLayers';
export * from './VSCLayoutActivitybarLeft';
export * from './VSCLayoutActivitybarRight';
export * from './VSCLayoutCentered';
export * from './VSCLayoutMenubar';
export * from './VSCLayoutPanelCenter';
export * from './VSCLayoutPanelJustify';
export * from './VSCLayoutPanelLeft';
export * from './VSCLayoutPanelOff';
export * from './VSCLayoutPanelRight';
export * from './VSCLayoutPanel';
export * from './VSCLayoutSidebarLeftOff';
export * from './VSCLayoutSidebarLeft';
export * from './VSCLayoutSidebarRightOff';
export * from './VSCLayoutSidebarRight';
export * from './VSCLayoutStatusbar';
export * from './VSCLayout';
export * from './VSCLibrary';
export * from './VSCLightbulbAutofix';
export * from './VSCLightbulb';
export * from './VSCLinkExternal';
export * from './VSCLink';
export * from './VSCListFilter';
export * from './VSCListFlat';
export * from './VSCListOrdered';
export * from './VSCListSelection';
export * from './VSCListTree';
export * from './VSCListUnordered';
export * from './VSCLiveShare';
export * from './VSCLoading';
export * from './VSCLocation';
export * from './VSCLockSmall';
export * from './VSCLock';
export * from './VSCMagnet';
export * from './VSCMailRead';
export * from './VSCMail';
export * from './VSCMapFilled';
export * from './VSCMap';
export * from './VSCMarkdown';
export * from './VSCMegaphone';
export * from './VSCMention';
export * from './VSCMenu';
export * from './VSCMerge';
export * from './VSCMilestone';
export * from './VSCMirror';
export * from './VSCMortarBoard';
export * from './VSCMove';
export * from './VSCMultipleWindows';
export * from './VSCMute';
export * from './VSCNewFile';
export * from './VSCNewFolder';
export * from './VSCNewline';
export * from './VSCNoNewline';
export * from './VSCNote';
export * from './VSCNotebookTemplate';
export * from './VSCNotebook';
export * from './VSCOctoface';
export * from './VSCOpenPreview';
export * from './VSCOrganization';
export * from './VSCOutput';
export * from './VSCPackage';
export * from './VSCPaintcan';
export * from './VSCPassFilled';
export * from './VSCPass';
export * from './VSCPersonAdd';
export * from './VSCPerson';
export * from './VSCPieChart';
export * from './VSCPin';
export * from './VSCPinnedDirty';
export * from './VSCPinned';
export * from './VSCPlayCircle';
export * from './VSCPlay';
export * from './VSCPlug';
export * from './VSCPreserveCase';
export * from './VSCPreview';
export * from './VSCPrimitiveSquare';
export * from './VSCProject';
export * from './VSCPulse';
export * from './VSCQuestion';
export * from './VSCQuote';
export * from './VSCRadioTower';
export * from './VSCReactions';
export * from './VSCRecordKeys';
export * from './VSCRecordSmall';
export * from './VSCRecord';
export * from './VSCRedo';
export * from './VSCReferences';
export * from './VSCRefresh';
export * from './VSCRegex';
export * from './VSCRemoteExplorer';
export * from './VSCRemote';
export * from './VSCRemove';
export * from './VSCReplaceAll';
export * from './VSCReplace';
export * from './VSCReply';
export * from './VSCRepoClone';
export * from './VSCRepoForcePush';
export * from './VSCRepoForked';
export * from './VSCRepoPull';
export * from './VSCRepoPush';
export * from './VSCRepo';
export * from './VSCReport';
export * from './VSCRequestChanges';
export * from './VSCRocket';
export * from './VSCRootFolderOpened';
export * from './VSCRootFolder';
export * from './VSCRss';
export * from './VSCRuby';
export * from './VSCRunAbove';
export * from './VSCRunAll';
export * from './VSCRunBelow';
export * from './VSCRunErrors';
export * from './VSCSaveAll';
export * from './VSCSaveAs';
export * from './VSCSave';
export * from './VSCScreenFull';
export * from './VSCScreenNormal';
export * from './VSCSearchStop';
export * from './VSCSearch';
export * from './VSCServerEnvironment';
export * from './VSCServerProcess';
export * from './VSCServer';
export * from './VSCSettingsGear';
export * from './VSCSettings';
export * from './VSCShield';
export * from './VSCSignIn';
export * from './VSCSignOut';
export * from './VSCSmiley';
export * from './VSCSortPrecedence';
export * from './VSCSourceControl';
export * from './VSCSplitHorizontal';
export * from './VSCSplitVertical';
export * from './VSCSquirrel';
export * from './VSCStarEmpty';
export * from './VSCStarFull';
export * from './VSCStarHalf';
export * from './VSCStopCircle';
export * from './VSCSymbolArray';
export * from './VSCSymbolBoolean';
export * from './VSCSymbolClass';
export * from './VSCSymbolColor';
export * from './VSCSymbolConstant';
export * from './VSCSymbolEnumMember';
export * from './VSCSymbolEnum';
export * from './VSCSymbolEvent';
export * from './VSCSymbolField';
export * from './VSCSymbolFile';
export * from './VSCSymbolInterface';
export * from './VSCSymbolKey';
export * from './VSCSymbolKeyword';
export * from './VSCSymbolMethod';
export * from './VSCSymbolMisc';
export * from './VSCSymbolNamespace';
export * from './VSCSymbolNumeric';
export * from './VSCSymbolOperator';
export * from './VSCSymbolParameter';
export * from './VSCSymbolProperty';
export * from './VSCSymbolRuler';
export * from './VSCSymbolSnippet';
export * from './VSCSymbolString';
export * from './VSCSymbolStructure';
export * from './VSCSymbolVariable';
export * from './VSCSyncIgnored';
export * from './VSCSync';
export * from './VSCTable';
export * from './VSCTag';
export * from './VSCTarget';
export * from './VSCTasklist';
export * from './VSCTelescope';
export * from './VSCTerminalBash';
export * from './VSCTerminalCmd';
export * from './VSCTerminalDebian';
export * from './VSCTerminalLinux';
export * from './VSCTerminalPowershell';
export * from './VSCTerminalTmux';
export * from './VSCTerminalUbuntu';
export * from './VSCTerminal';
export * from './VSCTextSize';
export * from './VSCThreeBars';
export * from './VSCThumbsdown';
export * from './VSCThumbsup';
export * from './VSCTools';
export * from './VSCTrash';
export * from './VSCTriangleDown';
export * from './VSCTriangleLeft';
export * from './VSCTriangleRight';
export * from './VSCTriangleUp';
export * from './VSCTwitter';
export * from './VSCTypeHierarchySub';
export * from './VSCTypeHierarchySuper';
export * from './VSCTypeHierarchy';
export * from './VSCUnfold';
export * from './VSCUngroupByRefType';
export * from './VSCUnlock';
export * from './VSCUnmute';
export * from './VSCUnverified';
export * from './VSCVariableGroup';
export * from './VSCVerifiedFilled';
export * from './VSCVerified';
export * from './VSCVersions';
export * from './VSCVmActive';
export * from './VSCVmConnect';
export * from './VSCVmOutline';
export * from './VSCVmRunning';
export * from './VSCVm';
export * from './VSCWand';
export * from './VSCWarning';
export * from './VSCWatch';
export * from './VSCWhitespace';
export * from './VSCWholeWord';
export * from './VSCWindow';
export * from './VSCWordWrap';
export * from './VSCWorkspaceTrusted';
export * from './VSCWorkspaceUnknown';
export * from './VSCWorkspaceUntrusted';
export * from './VSCZoomIn';
export * from './VSCZoomOut';